import { Fancyapps } from "@Libraries/Fancyapps";
import { Gallery } from "./_Gallery";
import { Video } from "@Base/Product/_Video";
import "./_ImageZoom.scss";

export class ImageZoom
{
	public Instance;
	private Gallery: Gallery;

	constructor(gallery: Gallery)
	{
		this.Gallery = gallery;
		this.Initialize();
	};

	private Initialize = (): void =>
	{
		this.ConfigureImageZoom();
	};

	private ConfigureImageZoom = (): void =>
	{
		const hlZoom = document.querySelector("#hlZoom");

		if (hlZoom !== null)
		{
			hlZoom.addEventListener("click", this.OpenImageZoom);
		}
	};

	private OpenImageZoom = async (e: Event): Promise<void> =>
	{
		e.preventDefault();

		const target = e.currentTarget as HTMLLinkElement;
		const currentIndex = parseInt(target.getAttribute("data-index"));
		const fancyapps = await Fancyapps.Import();
		const Fancybox = fancyapps.Fancybox;
		const zoomImages = this.Gallery.Images.map(image =>
		{
			return {
				src: image.ZoomUrl,
				thumb: image.ThumbUrl,
				type: image.Type
			};
		});

		this.Instance = new Fancybox(zoomImages, {
			startIndex: currentIndex,
			infinite: true,
			on: {
				"shouldClose": (): void =>
				{
					Video.Stop();
				},
				"destroy": (): void =>
				{
					Video.Stop();
				},
				"Carousel.ready": (fancybox, carousel): void =>
				{
					if (carousel.page && carousel.pages.length > 0)
					{
						const slide = carousel.pages[carousel.page].slides[0];

						if (slide.src.includes("#video"))
						{
							const videoTarget: HTMLElement = document.querySelector(slide.src);

							if (videoTarget !== null)
							{
								const videoIndex = videoTarget.getAttribute("data-video");

								if (videoIndex !== "" && videoIndex !== null)
								{
									Video.Play(parseInt(videoIndex));
								}
							}
						}
					}
				},
				"Carousel.change": (fancybox, carousel, slide): void =>
				{
					const newImage = this.Gallery.Links[slide];

					newImage.dispatchEvent(new Event("click", { cancelable: true }));
					this.Gallery.UpdateScrollPosition();
					Video.Stop();
				}
			}
		});
	};
}